import React from 'react';

export default class SideEnd extends React.Component {

  render() {
    return (
      <div className={`SideEnd ${this.props.direction} hidden-sm-down`}></div>
    );
  }
};
